import { atom } from 'jotai';

// 是否在 KB 的切水果
export const isInKbFruitGameAotm = atom<boolean>(false);